// extracted by mini-css-extract-plugin
module.exports = {"imageLink":"_3RcA-bx","image":"_1XvgPXE","text":"_1CixOZ3"};